import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query} from 'react-apollo'
import 'react-table/react-table.css'
import {Container, Row, Col, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import moment from 'moment'
import {withRouter} from 'react-router-dom'

import QUERY from '../../../queries/reports/users_annual_leave'

class AnnualLeaveReport extends Component {

  constructor(props) {
    super(props);
    const year = (props.match.params.year) ? props.match.params.year : moment().format('YYYY')
    this.state = {
      year
    };
  }

  render() {
    const {year} = (this.props.match.params.year) ? this.props.match.params : this.state
    const previousYear = Number(year) - 1
    const nextYear = Number(year) + 1

    return (
      <Container fluid className="mt-3">
        <h1>Annual Leave Report</h1>
        <div className="mt-3 mb-3 d-flex flex-row align-items-end justify-content-between">
          <Button
              size="sm"
              color="primary"
              onClick={() => {
                this.props.history.push(`/reports/annual_leave/${previousYear}`)
              }}>
              <FontAwesomeIcon
                  icon="chevron-left"
              />{' '}
              {previousYear}
          </Button>
          <h4>{year}</h4>
          <Button
              size="sm"
              color="primary"
              className="float-right"
              onClick={() => {
                this.props.history.push(`/reports/annual_leave/${nextYear}`)
              }}>
                {nextYear}{' '}
                <FontAwesomeIcon
                    icon="chevron-right"
                />
          </Button>
        </div>
          <Row>
            <Col>
              <Query query={QUERY} fetchPolicy="network-only" variables={{year}}>
                {({data, loading}) => {
                    return (<ReactTable
                      data={data.active_users}
                      loading={loading}
                      pageSize={!loading ? data.active_users.length : 100}
                      showPagination={false}
                      style={{display: 'flex', flex: 1, fontSize: '14px'}}
                      columns={[
                          {
                              Header: "User",
                              id: 'full_name',
                              accessor: 'full_name',
                              filterable: true,
                              filterMethod: (filter, row) => {
                                  if(!filter.value) return true

                                  return row.full_name.toLowerCase().includes(filter.value.toLowerCase())
                              },
                          },
                          {
                              Header: `Annual Leave (Days)`,
                              id: 'year_leave',
                              accessor: 'year_leave',
                              filterable: false,
                          },
                          {
                              Header: "Leave Used (Days)",
                              id: 'year_leave_used',
                              accessor: 'year_leave_used',
                              filterable: false,
                          },
                      ]}
                      SubComponent={row => {

                        console.log(`row: ${JSON.stringify(row)}`)

                        return (
                            <div style={{ padding: "20px" }}>
                                <ReactTable
                                    data={row.original.active_annual_leave}
                                    defaultPageSize={10}
                                    columns={[
                                        {
                                            Header: "Start Date",
                                            id: 'start_date',
                                            accessor: ({start_date, start_of_day}) => `${moment(start_date).format('DD/MM/YY')} (${(start_of_day) ? 'Start of day' : 'Afternoon'})`,
                                            filterable: false,
                                        },
                                        {
                                          Header: "End Date",
                                          id: 'end_date',
                                          accessor: ({end_date, end_of_day}) => `${moment(end_date).format('DD/MM/YY')} (${(end_of_day) ? 'End of day' : 'Afternoon'})`,
                                          filterable: false,
                                        },
                                        {
                                          Header: "Days Used",
                                          id: 'days_used',
                                          accessor: 'days_used',
                                          filterable: false,
                                        },
                                    ]}
                                    className="-striped -highlight"
                                />
                            </div>
                        );
                      }}
                      className="-striped -highlight"

                  />)
                }}
              </Query>
            </Col>
          </Row>
      </Container>
    )
  }
}

export default withRouter(AnnualLeaveReport)